import { Link } from "react-router-dom";
import type { FC } from "react";

import EnvelopesOverview from "components/EnvelopesOverview/EnvelopesOverviewSimple";
import ThemeProgress from "./ThemeProgress";
import IconArrowRight from "images/icons/arrow-right.svg";

import type { ThemeRowDataType } from "utils/common/themes";

interface Props {
  theme: ThemeRowDataType;
  challenge?: { theme?: string; name?: string };
}

const ThemeRow: FC<Props> = ({ theme, challenge }) => {
  if (!theme) return null;

  return (
    <Link to={theme.tutoringId} className="theme-row">
      <div className="theme-row__size--large">
        <div className="theme-row__name">
          {theme.title}
          {challenge ? <div className="theme-row__badge">Týdenní&nbsp;výzva</div> : null}
        </div>
        <div className="theme-row__description">{theme.description}</div>
      </div>
      <div className="theme-row__size--medium text-center">{theme.avgPoints}</div>
      <div className="theme-row__size--medium align-items-center">
        <EnvelopesOverview
          envelopes={{
            red: theme.assignmentsRed,
            green: theme.assignmentsGreen,
            yellow: theme.assignmentsYellow,
          }}
        />
      </div>
      <div className="theme-row__size--medium theme-row__progress">
        <ThemeProgress progress={theme.themeProgress} isBadge={theme.isBadge} />
      </div>
      <div className="theme-row__size--small">
        <IconArrowRight className={"flex-shrink-0"} />
      </div>
    </Link>
  );
};

export default ThemeRow;
